<template>
  <div
    class="cat-cms-content"
    :data-location="location"
    v-html="_getLocationContent"
  ></div>
</template>
<script lang="ts">
import { defineComponent } from "vue";
export default defineComponent({
  name: "CatCmsContent",
  props: {
    viewtree: [Object],
    location: {
      type: String,
      default: null
    },
    content: {
      type: String,
      default: "<!-- NO_CMS_CONTENT for location: " + location + " -->"
    }
  },
  computed: {
    _getLocationContent: function () {
      const nonceMatch = (
        document.querySelector(
          'meta[http-equiv="Content-Security-Policy"]'
        ) as any
      )?.content?.match(/style-src\s+[^;]*'nonce-([^']*)'/);
      const cspNonce = nonceMatch?.length > 1 ? nonceMatch[1] : undefined;
      const withHeadNonce = (html?: string) =>
        cspNonce
          ? html?.replaceAll(/\s+nonce=['"][^'"]*['"]/g, ` nonce="${cspNonce}"`)
          : html;
      for (let n in this.viewtree) {
        let node = this.viewtree[n];
        if (node.kv && node.kv["location-name"] === this.location) {
          return withHeadNonce(node.html);
        }
      }
      return withHeadNonce(this.content);
    }
  }
});
</script>
